"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExerciseServiceImpl = void 0;
var ExerciseProviderImpl_1 = require("./provider/firebase/ExerciseProviderImpl");
var ExerciseProviderImpl_2 = require("./provider/airabbi/ExerciseProviderImpl");
var ExerciseServiceImpl = (function () {
    function ExerciseServiceImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.createExercise = function (exercise, uid) {
            return _this.provider.createExercise(exercise, uid);
        };
        this.updateExercise = function (exercise, internalTeacherResourceUid) {
            return _this.provider.updateExercise(exercise, internalTeacherResourceUid);
        };
        this.cloneSpecificTeacherExercises = function (srcEmail, unit) {
            return _this.provider.cloneSpecificTeacherExercises(srcEmail, unit);
        };
        this.getAllExercises = function (isProjected) {
            return _this.provider.getAllExercises(isProjected);
        };
        this.getMyExercisesByPagination = function (codeType, skip, limit, sort, searchString, excludedIds) {
            return _this.provider.getMyExercisesByPagination(codeType, skip, limit, sort, searchString, excludedIds);
        };
        this.getExercise = function (id) {
            return _this.provider.getExercise(id);
        };
        switch (cfg.provider) {
            case 'firebase':
                this.provider = new ExerciseProviderImpl_1.ExerciseProviderImpl(cfg);
                break;
            case 'airabbi':
                this.provider = new ExerciseProviderImpl_2.ExerciseProviderImpl(cfg);
                break;
        }
    }
    ExerciseServiceImpl.prototype.init = function (env, cfg) {
        return this.provider.init(env);
    };
    ExerciseServiceImpl.prototype.setDebuggable = function (debuggable) {
        return this.provider.setDebuggable(debuggable);
    };
    ExerciseServiceImpl.prototype.getSharedExercises = function (codeType, sharedType, uid) {
        return this.provider.getSharedExercises(codeType, sharedType, uid);
    };
    ExerciseServiceImpl.prototype.shareExercise = function (exerciseObj, sharedType) {
        return this.provider.shareExercise(exerciseObj, sharedType);
    };
    ExerciseServiceImpl.prototype.cloneSharedExercise = function (sharedType, exerciseId) {
        return this.provider.cloneSharedExercise(sharedType, exerciseId);
    };
    ExerciseServiceImpl.prototype.searchExercise = function (filter) {
        return Promise.resolve([]);
    };
    ExerciseServiceImpl.prototype.removeExercise = function (id) {
        return this.provider.removeExercise(id);
    };
    ExerciseServiceImpl.prototype.removeShareExercise = function (id, shareType) {
        return this.provider.removeShareExercise(id, shareType);
    };
    ExerciseServiceImpl.prototype.stopAllMonitor = function () {
    };
    return ExerciseServiceImpl;
}());
exports.ExerciseServiceImpl = ExerciseServiceImpl;
//# sourceMappingURL=ExerciseServiceImpl.js.map